import React, { useState, useEffect,useImperativeHandle ,forwardRef} from "react";
import {
  Modal,
  Button,
  Space,
  Input,
  Form,
  Select,
  message,
  Row,
  Col,
  Typography,
  notification
} from "antd";
import { Table } from "antd";
import { SearchOutlined, EditFilled,DeleteFilled,FrownOutlined,PrinterOutlined,SmileOutlined } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import Passprint from "./passprint";
import { path, src } from "../network/conn";
const key = "updatable";
const user = sessionStorage.getItem('user');
const openMessageLoading = (load) => {
  message.loading({ content: load, key });
};
const openMessageSuccess = (loaded) => {
  message.success({ content: loaded, key, duration: 2 });
};
const Scandata = forwardRef((Props,refpro) => {
  useImperativeHandle(refpro, () => ({
    handlePropsReload(){
      fetchDoctor();
      fetchPatient();
    }
    }));
  const [loading, setLoading]              = useState(false);
  const [visible, setVisible]              = useState(false);
  const [dataSource, setdataSource]        = useState([]);
  const [scanColumnData,setScanColumnData] = useState([]);
  const [size, setSize]                    = useState();
  const [patientList, setPatientList]      = useState([]);
  const [doctorList, setDoctorList]        = useState([]);
  const [scanList, setScanList]            = useState([]);
  const [totalRecord, settotalRecord]      = useState(0);
  const [paymentList,setPaymentList]       = useState([]);
  const [submitType, setsubmitType]        = useState("insert");
  const [checkedType, setCheckedType]      = useState(false);
  const [netamount,setNetamount]           = useState(0);
  const [passPrintData,setpassPrintData]   =useState({});
  const [passprintModal,setpassprintModal] =useState(false);
  const [statusList,setStatusList]         =useState(['Process','Completed','Cancel'])
  const [userSetting,setUserSetting]       = useState({});
  const [form]                             = Form.useForm();
  const logUser = window.sessionStorage.getItem("user");
  const addScan = () => {
    setsubmitType("insert");
    fetchCount();
    showLargeDrawer();
  };
  const showLargeDrawer = () => {
    console.log('open')
    setSize("large");
    setVisible(true);
    form.setFieldsValue({
      discount : 0
    })
  };
  const drawerClose = () => {
    setVisible(false);
    form.resetFields();
    setScanColumnData([]);
  };
  const { Option } = Select;
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  };
  const openNotification = () => {
    notification.open({
      message: 'Error',
      description:
        'Scan Item Already Exists',
      icon: <FrownOutlined style={{ color: 'red' }}/>,
    });
  };
  
const onFinish = (e) =>{
  console.log(e);
  let patientData = patientList.filter((list)=>{return list.patientid == e.patient});
  let scanData    = scanList.filter((list)=>{return list.code == e.scancode});
  let data = Object.assign({},e);
  data.scanname = scanData[0].scan;
  console.log('data',data);
  setScanColumnData([...scanColumnData,data]);
  form.setFieldsValue({
    scancode : null,
    amount   : null
  })
}
  const handleSubmit = (e) => {
    if(scanColumnData.length == 0){
        notification.open({
          message: "Error",
          description: "No Data Found",
          icon: <SmileOutlined style={{ color: "#108ee9", color: "red" }} />,
        });
      return;
    }
    const data = {};
    data['patient']   = form.getFieldValue('patient');
    data['doctor']    = form.getFieldValue('doctor');
    data['age']       = form.getFieldValue('age');
    data['height']    =form.getFieldValue('height');
    data['weight']    = form.getFieldValue('weight');
    data['payment']   = form.getFieldValue('payment');
    data['scandata']  = scanColumnData;
    data['user']      = user;
    data['discount']  = form.getFieldValue('discount');
    data['amountgiven'] = form.getFieldValue('amountgiven');
    data['finalamount'] = form.getFieldValue('finalamount');
    data['balance']    = form.getFieldValue('balance');
    data['submit']     = submitType;
    data['scancode']   = form.getFieldValue('code');
    data['process']    = form.getFieldValue('status');
    data['time']       = form.getFieldValue('timecode');
    data['date']       = form.getFieldValue('datecode');
    data['user']       = logUser;
     openMessageLoading("Adding Scan", 20);
    let BaseURL = path + src + "insert_scan_entry.php";
    axios
      .post(BaseURL, data)
      .then((response) => {
        openMessageSuccess(response.data, 20);
        setVisible(false);
        drawerClose();
        fetchTableData();
        form.resetFields();
        Props.onScanRefresh();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchTableData = () => {
    setLoading(true);
    let BaseURL = path + src + "scanentrylist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        let sortedData = response.data.sort((a,b)=>{return b.code.split('-')[1]-a.code.split('-')[1]});
        setdataSource(sortedData);
        settotalRecord(sortedData.length);
        setVisible(false);
        setLoading(false);
        Props.onScanDataEntered();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  
  const fetchPatient = () => {
    let BaseURL = path + src + "patientlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setPatientList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchPayment = () => {
    let BaseURL = path + src + "paymentlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setPaymentList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchDoctor = () => {
    let BaseURL = path + src + "doctorlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setDoctorList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchScan = () => {
    let BaseURL = path + src + "scanlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setScanList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
 
  const fetchCount = () => {
        let value = dataSource.length + 1 ; 
        let valueStr = "0000"+ value.toString();
        form.setFieldsValue({
          code: "SCEN-" + (valueStr.substr(-4)),
          submit: "insert",
        });
  };
  const handleDeleteScanData = (record)=>{
    console.log(record);
    setScanColumnData((data)=>{
      console.log(data);
      return data.filter((list)=> list.scancode != record.scancode);
    })
  }
  const handleEditScanData = (record)=>{
   form.setFieldsValue({
    scancode : record.scancode,
    amount   : record.amount 
   });
   handleDeleteScanData(record);
  }
  const onEditScan = (record) => {
    setsubmitType("update");
    showLargeDrawer();
    console.log(record);
    let invCode = record.code;
    let BaseURL =
      path +
      src +
      "edit_scan_data_entry.php?code=" +
      invCode;
    axios
      .get(BaseURL)
      .then((responseData) => {
        let response = responseData.data;
        console.log(response);
        form.setFieldsValue({
          code        : response.code,
          patient     : response.patient,
          doctor      : response.doctor,
          height      : response.height,
          weight      : response.weight,
          age         : response.age,
          payment     : response.payment,
          discount    : response.discount,
          amountgiven : response.amountgiven,
          balance     : response.balance,
          status     : response.process == "" ? 'Process' : response.process,
          datecode   : response.date,
          timecode    : response.time
        });
        setScanColumnData( response.product);
      }).catch((error) => {
        console.log(error);
      });
  };
  const handleDiscount = ()=>{
     form.setFieldsValue({
      finalamount : Number(netamount - form.getFieldValue('discount')).toFixed(2),
     });
     handleCashGiven();
  }
  const handleCashGiven = () =>{
    let totalAmount = form.getFieldValue('finalamount');
    let amountGiven = form.getFieldValue('amountgiven');
    form.setFieldsValue({
      balance : Number(amountGiven - totalAmount).toFixed(2)
    })
  }
  const handleScanAmount = (e) =>{
   let scanData = scanList.find((list)=>{return list.code == e});
   console.log(scanData);
   let scanRestriction = scanColumnData.find((list)=>{return list.scancode == e});
   console.log(scanRestriction);
  if(scanRestriction){
   console.log('foundData');
   openNotification();
   return;
  }
  form.setFieldsValue({
    amount : scanData.price,
  })

  }

  const handlePrint = (value) => {
    let invCode = value.code;
    console.log(value);
    let BaseURL =
      path +
      src +
      "fetch_bill_details.php?code=" +
      invCode;
    axios
      .get(BaseURL)
      .then((response) => {
        console.log('data',response.data);
        setpassPrintData(response.data);
         setpassprintModal(true);
       setTimeout(
        ()=>{
          document.getElementById("getPrintButton").click();
        },200
       );
      })
      .then(() => console.log())
      .catch((error) => {
        console.log(error);
      });
  }; 
  const closeModal = () =>{
    setpassprintModal(false);
    setpassPrintData([]);
  }
  const profile = window.sessionStorage.getItem("profile");
 const fetch_profile_permission = (profile) =>{
   console.log('profile',profile);
   let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
   axios
   .get(BaseURL)
     .then((response) => {
       console.log(response.data);
       let dataObj = {};
       response.data.map((list)=>{
         let permissionObj = {};
         if(list.filename == 'scanentry'){
         permissionObj['add']      = list.add;
         permissionObj['edit']     = list.edit;
         permissionObj['delete']   = list.delete;
         permissionObj['show']     = list.show;
         permissionObj['print']    = list.print;
         permissionObj['excel']    = list.excel;
         permissionObj['profile']  = list.profile;
         dataObj[list.filename]    =  permissionObj;
         setUserSetting(permissionObj);
         }
       })
      
      console.log('dataObj',dataObj);
     })
     .catch((error) => {
       //openMessageSuccess(error, 10);
       console.log(error);
     });
   }
  useEffect(() => {
    fetch_profile_permission(profile);
    fetchTableData();
    fetchPatient();
    fetchDoctor();
    fetchScan();
    fetchPayment();
  }, []);
  const scanColumn = [
    {
      key: "1",
      title: "Scan",
      dataIndex: "scanname",
    },
    {
      key: "2",
      title: "Amount",
      dataIndex: "amount",
    },
   
    {
      key: "3",
      title: "Edit",
      render: (record) => (
        <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            handleEditScanData(record);
          }}
        >
          <EditFilled />
        </Button>
      ),
    },
      
    {
      key: "4",
      title: "Delete",
      render: (record) => (
        <Button
          title=""
          size="small"
          type="danger"
          onClick={() => {
            handleDeleteScanData(record);
          }}
        >
          <DeleteFilled />
        </Button>
      ),
    },
    // {
    //   key: "8",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];
  const columns = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "sno",
      sorter: (record1, record2) => {
        return record1.id > record2.id;
      },
    },
    {
      key: "6",
      title: "Code",
      dataIndex: "code",
    },
    {
      key: "2",
      title: "Date",
      dataIndex: "date",
    },
    {
      key: "3",
      title: "Patient",
      dataIndex: "patientname",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.patientname.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "4",
      title: "Status",
      dataIndex: "process",
    },
    // {
    //   key: "5",
    //   title: "price",
    //   dataIndex: "sellingprice",
    // },
    {
      key: "6",
      title: "Amount",
      dataIndex: "amount",
    },
    {
      key: "7",
      title: "Edit",
      render: (record) => (
       Number(userSetting.edit) == 1 ? <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            onEditScan(record);
          }}
        >
          <EditFilled />
        </Button> : ''
      ),
    },
    {
        key: "8",
        title: "Print",
          render: (record) => (
          Number(userSetting.print) == 1 ?  <Button size="small" type="danger" onClick={() => handlePrint(record)}>
              <PrinterOutlined />
            </Button> : ''
          ),
      },
    // {
    //   key: "8",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];
  return (
    <>
        { Number(userSetting.add) == 1 ? <Button type="primary" onClick={addScan}>
          Add Scan +
        </Button> :'' }
      <Modal
        title={submitType == "insert" ? "Add Scan" : "Edit Scan"}
        style={{ top: 20 }}
        visible={visible}
        onOk={() => drawerClose()}
        onCancel={() => drawerClose()}
        width={"95vw"}
        maskClosable={false}
        footer={null}
      >
        <Form layout="vertical" form={form} name="nest-messages" onFinish={onFinish}>
        {submitType == 'insert' ? '' : <Row gutter={24}>
          <Col span={6}>
        <Form.Item name="datecode" label="Date" hidden={false}>
            <Input placeholder="Enter Your Scancode" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={6}>
          <Form.Item name="timecode" label="Time" hidden={false}>
            <Input placeholder="Enter Your Scancode" autocomplete="off" />
          </Form.Item>
          </Col>
          </Row> }
          <Row gutter={24}>
        
            <Col span={8}>
          <Form.Item
            name="code"
            label="Scancode"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Scancode" autocomplete="off"  disabled={true} style={{color:"red"}}/>
          </Form.Item>
          </Col>
          
          <Col span={8}>
          <Form.Item
            name="patient"
            label="Patient"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select Patient"
            >
              {patientList.map((list) => (
                <Option value={list.code}>{`${list.patientname}/${list.mobile}`}</Option>
              ))}
            </Select>
          </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item
            name="doctor"
            label="Doctor"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select Doctor"
            >
              {doctorList.map((list) => (
                <Option value={list.code}>{list.doctor}</Option>
              ))}
            </Select>
          </Form.Item>
          </Col>
          </Row>         
          <Row gutter={24}>
          <Col span={8}>
          <Form.Item name="age" label="Age" >
            <Input placeholder="Enter Age" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item name="height" label="Height" >
            <Input placeholder="Enter Height" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item name="weight" label="Weight" >
            <Input placeholder="Enter weight" autocomplete="off" />
          </Form.Item>
          </Col>
          </Row>
          <Row gutter={24}>
          <Col span={8}>
          <Form.Item name="scancode" label="ScanType" >
          <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select ScanList"
              onChange={handleScanAmount}
            >
              {scanList.map((list) => (
                <Option value={list.code}>{list.scan}</Option>
              ))}
            </Select>
          </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item name="amount" label="Amount" >
            <Input placeholder="Enter Amount" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={submitType == 'insert' ? 6 : 3}>
          <Form.Item name="payment" label="Payment" >
          <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select Payment"
            >
              {paymentList.map((list) => (
                <Option value={list.code}>{list.payment}</Option>
              ))}
            </Select>
          </Form.Item>
          </Col>
         {submitType != 'insert' ? <Col span={3}>
          <Form.Item name="status" label="Status" >
          <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select Status"
            >
              {statusList.map((list) => (
                <Option value={list}>{list}</Option>
              ))}
            </Select>
          </Form.Item>
          </Col> : '' }
          <Col span={2}>
          <Form.Item label=" ">
             <Button type="primary" htmlType="submit">
             +Add
            </Button>
          </Form.Item>
          </Col>
          </Row>
          <Table
        bordered
        className="tableData"
        dataSource={scanColumnData}
        columns={scanColumn}
        loading={loading}
        pagination={{ pageSize: 10, total: { totalRecord } }}
        summary={(tableData) => {
          let taxValue=0;
          tableData.map((tableData)=>{ 
              taxValue+=Number(tableData.amount);
           });
           setNetamount(taxValue);
           handleDiscount();
          return (
          <>
            <Table.Summary.Row>
            <Table.Summary.Cell colSpan={1}>
            <Typography
                  style={{ fontSize: "18px", fontWeight: "bold",textAlign:"center" }}
                >
                Total
                </Typography>
              </Table.Summary.Cell>
              <Table.Summary.Cell colSpan={1} align="left">
                <Typography
                  style={{ fontSize: "18px", fontWeight: "bold",textAlign:"center" }}
                >
                 {taxValue.toFixed(2)}
                </Typography>
              </Table.Summary.Cell>
              <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
            </Table.Summary.Row>
          </>
        ); }}
      ></Table>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item name="discount" label="Discount" onKeyUp={handleDiscount} className="labelText" >
            <Input placeholder="Enter discount" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={6}>
          <Form.Item name="finalamount" label="FinalAmount" className="labelText" >
            <Input placeholder="Final Amount" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={6}>
          <Form.Item name="amountgiven" label="Amount Given" onKeyUp={handleCashGiven} className="labelText" >
            <Input placeholder="Enter discount" autocomplete="off" />
          </Form.Item>
          </Col>
          <Col span={6}>
          <Form.Item name="balance" label="Balance" className="labelText" >
            <Input placeholder="Final Amount" autocomplete="off" />
          </Form.Item>
          </Col>
          </Row>
          <Form.Item>
            <Button type="primary" onClick={handleSubmit} >
              {submitType == "insert" ? "Submit" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Table
        bordered
        className="tableData"
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 5, total: { totalRecord } }}
      ></Table>
      <Modal
        visible={passprintModal}
        title="Pass"
        style={{ top: 20 }}
        onOk={closeModal}
        onCancel={closeModal}
        width={1400}
        footer={null}
        maskClosable={false}
      >
        
          <Passprint data={passPrintData} />
        
      </Modal>
    </>
  );
});
export default Scandata;
